export default () => {
    return "https://staging-api.menehariya.com/v1/api"
    // return "http://localhost:3002/v1/api"
};


